import { dictaminarActa, generarPago, marcarPagoDictamen } from "../services/accionActa.service";
import { getActas, getActasCsv, getActasNotificadorCsv } from "../services/actas.service";
import { useFilterActas } from "../store/filterActasStore";
import { useGeneralAppStore } from "../store/generalAppStore";

const { setPaginateCfg } = useFilterActas.getState();
const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

export const dictaminarActaHandler = async (payload, setRefetch) => {
  const result = await dictaminarActa(payload);
  if (result) {
    if (setRefetch) {
      setRefetch(true);
    }
    handlerModal({ modal: false, modalName: "modal_dictaminar_acta" });
    handlerModal({ modal: false, modalName: "acta_detalle" });
  }
};

export const generarPagoHandler = async (payload, setRefetch) => {
  const result = await generarPago(payload);
  if (result) {
    if (setRefetch) {
      setRefetch(true);
    }
    handlerModal({ modal: false, modalName: "modal_generar_pago" });
    handlerModal({ modal: false, modalName: "acta_detalle" });
  }
};

export const getActasCsvHandler = async (setActasCsv, payload) => {
  const result = await getActasCsv(payload);
  if (result) {
    setActasCsv(result);
    // setPaginateCfg({ ...paginado });
  }
};

export const getActasCsvNotificadorHandler = async (setActasCsv, payload) => {
  const result = await getActasNotificadorCsv(payload);
  if (result) {
    setActasCsv(result);
    // setPaginateCfg({ ...paginado });
  }
};
export const marcarPagoDictamenHandler = async (payload, setRefetch) => {


  const result = await marcarPagoDictamen(payload);

  if (result) {
    if (setRefetch) {
      setRefetch(true);
    }
    handlerModal({ modal: false, modalName: "modal_pago_dictamen" });
    handlerModal({ modal: false, modalName: "acta_detalle" });
  }
};
